module.exports = __webpack_public_path__ + "img/PRYM-blue-small.44268e23.png";